import { PUBLIC_URL } from '@/constants/common';

const ChatIcon = (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => <img alt='Chat icon' {...props} src={`${PUBLIC_URL}/chat-icon.gif`} />;

export { ChatIcon };
